<script lang="ts" setup>
import { TOP_MAGAZINE_SLUGS, customPaths } from "~/utils/constants"

const route = useRoute()
const { locale } = useI18n()
const isLoading = ref(true)

const { data, error, pending } = await usePage(
  `/api/gluon/fetchArticlePage/${locale.value}/${
    route.params.slug as string
  }/article.js`
)

// As per TF-2146, when an article DOESN'T have a connected category that exists OR ITS NOT "tutti-i-post", then return an "404" error paged
const categoryExists =
  data?.value?.categories?.some(
    (category) => category.slug === route.params.category
  ) || route.params.category === TOP_MAGAZINE_SLUGS.allPosts

if (!categoryExists || error.value) throw createError({ statusCode: 404 })

// As per TF-2737, when using "tutti-i-post" category slug, redirect to the canonical page URL
const mainCategorySlug = data?.value?.categories?.[0]?.slug
if (mainCategorySlug && route.params.category !== mainCategorySlug) {
  if (!!mainCategorySlug) {
    navigateTo(
      `${customPaths.magazineRoot}/${mainCategorySlug}/${route.params.slug}`,
      {
        redirectCode: 301
      }
    )
  }
}

onMounted(() => {
  useTimeoutFn(() => {
    isLoading.value = false
  }, 500)
})
</script>

<template>
  <div class="article-page">
    <SkeletonSingleArticle
      v-if="isLoading || pending"
      class="hidden-no-script"
    />
    <PagesArticle
      v-if="data"
      v-bind="data"
      :class="{ hidden: isLoading }"
      class="show-no-script"
    />
  </div>
</template>
